// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Service Import
import walletWatchService from '@src/services/walletWatchService'

export const getData = createAsyncThunk('wallets/getData', async params => {
  const { page, perPage, search } = params
  const skipCount = (page - 1) * perPage
  const response = await walletWatchService.getWalletWatches({
    search,
    skipCount,
    totalCount: perPage
  })
  return {
    params,
    data: response.data.data.items,
    totalCount: response.data.data.totalCount
  }
})

export const walletsSlice = createSlice({
  name: 'wallets',
  initialState: {
    data: [],
    totalCount: 0,
    params: {}
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.params = action.payload.params
      state.totalCount = action.payload.totalCount
    })
  }
})

export default walletsSlice.reducer
